import React, { useEffect, useState } from 'react';
import AppHeader from '../../component/AppHeader/app-header';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './PaymentSuccess.scss';

const PaymentSuccessPage = () => {
	const navigate = useNavigate();
	// const [searchParams] = useSearchParams();
	// const [loading, setLoading] = useState(true);
	// const [subscriptionData, setSubscriptionData] = useState(null);

	// const subscriptionId = searchParams.get('subscription_id');

	// useEffect(() => {
	// 	if (!subscriptionId) {
	// 		navigate('/subscription-plan');

	// 		return;
	// 	}

	// 	const fetchOrder = async () => {
	// 		try {
	// 			const response = await fetch(`http://localhost:5001/api/v2/subscription/${subscriptionId}`);

	// 			if (!response.ok) {
	// 				throw new Error('Failed to fetch subscription');
	// 			}

	// 			const result = await response.json();

	// 			setSubscriptionData(result?.data);
	// 		} catch (err) {
	// 			console.error(err);
	// 			navigate('/subscription-plan');
	// 		} finally {
	// 			setLoading(false);
	// 		}
	// 	};

	// 	fetchOrder();
	// }, [subscriptionId, navigate]);

	// if (loading) {
	// 	return (
	// 		<div className="payment-success-container">
	// 			<div className="payment-card">Loading...</div>
	// 		</div>
	// 	);
	// }

	// if (!subscriptionData) {
	// 	return null;
	// }

	// const {
	// 	subscription_id,
	// 	plan_name,
	// 	billing_period,
	// 	amount,
	// 	currency,
	// 	customer,
	// 	created_at,
	// 	payment_id,
	// } = subscriptionData;

	// const tax = amount * 0.18;

	// const total = amount + tax;

	return (
		<>
			<AppHeader title="Payment Status" />
			<main className="main-wrapper">
				<div className="payment-success-container">
					<div className="payment-card">
						{/* HEADER */}
						<div className="payment-header">
							<div className="success-icon">✔</div>
							<div>
								{/* <p className="order-id">ORDER #{subscription_id}</p> */}
								<p className="order-id">ORDER #15255</p>
								<h3>Payment Successful</h3>
								<p className="email-text">We’ve sent a confirmation email to user@example.com</p>
							</div>
						</div>

						{/* BODY */}
						<div className="payment-body">
							{/* LEFT SIDE */}
							<div className="plan-details">
								<div className="plan-card">
									<div className="plan-header">
										<h5>Plan Details</h5>
									</div>

									<div className="plan-content">
										{/* <div>
											<strong>{plan_name} Plan</strong>
											<p>{billing_period} Plan • Pro Features</p>
											<p className="valid">
												Valid Till: {created_at ? new Date(created_at).toDateString() : '-'}
											</p>
										</div> */}
										<div>
											<strong>Test Plan</strong>
											<p>1 Plan • Pro Features</p>
											<p className="valid">Valid Till: 30</p>
										</div>

										{/* <span className="price">₹{amount}</span> */}
										<span className="price">₹{222}</span>
									</div>
								</div>

								{/* NEXT STEPS */}
								<h6 className="mt-4">What’s Next?</h6>

								<div className="steps">
									<div className="step-box">
										<span>1</span>
										<div>
											<strong>Setup Organization</strong>
											<p>Configure your business & GST info</p>
										</div>
									</div>

									<div className="step-box">
										<span>2</span>
										<div>
											<strong>Setup Inventory</strong>
											<p>Add products and manage your stock</p>
										</div>
									</div>

									<div className="step-box">
										<span>3</span>
										<div>
											<strong>Start Creating Invoices</strong>
											<p>Create your first invoice and send to customers</p>
										</div>
									</div>
								</div>

								<button
									className="btn-primary"
									onClick={() => navigate('/organizationDetail')}
								>
									Complete Organisation Setup
								</button>
							</div>

							{/* RIGHT SIDE */}
							<div className="order-summary-payment">
								<h5>Order Summary</h5>

								<div className="summary-row">
									<span>Sub Total</span>
									{/* <span>₹{amount}</span> */}
									<span>₹{200}</span>
								</div>

								<div className="summary-row discount">
									<span>Discount</span>
									{/* <span>-₹{discount}</span> */}
								</div>

								<div className="summary-row">
									<span>Taxes</span>
									{/* <span>₹{tax}</span> */}
									<span>₹{20}</span>
								</div>

								<hr className="border-2 border-dark opacity-50" />

								<div className="summary-row total">
									<span>Total Paid</span>
									{/* <span>₹{total}</span> */}
									<span>₹{220}</span>
								</div>

								<p className="paid-with">
									Paid via ****
									{/* {payment_id?.slice(-4)} */}
									2121
								</p>

								<button
									className="btn-download"
									onClick={() => {
										// window.open(
										// 	`http://localhost:5001/api/v2/subscription/invoice/${subscription_id}`,
										// 	'_blank',
										// );
									}}
								>
									Download Invoice
								</button>
							</div>
						</div>
					</div>
				</div>
			</main>
		</>
	);
};

export default PaymentSuccessPage;
